export function initScrollProgress() {
  const fill = document.querySelector(".scroll-progress-fill");
  if (!fill) return;

  const update = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const progress = Math.min((scrollTop / docHeight) * 100, 100);
    fill.style.height = `${progress}%`;
  };

  window.addEventListener("scroll", update);
  update();
}
